import React, { useLayoutEffect, useRef, Component } from "react"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import { graphql } from "gatsby"
import { RightArrow, ChefHat, Coffee, International } from "../../icons"
import { gsap } from "gsap"
import AnimationButton from "./animation-button"
import parse from "html-react-parser"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

const LandingBanner = ({ title, buttons, image, video, theme, special }) => {
    const headingRef = useRef()

    React.useEffect(() => {
      const words = headingRef?.current?.querySelectorAll(".word")

      const tl = gsap.timeline({ defaults: { duration: 1, ease: "power4.out" } })

      tl.set(words, { overflow: "hidden" })
        .to({}, 0.5, {})
        .set(words, { y: 100, skewX: -10, rotateX: -1, opacity: 0, stagger: 0.1 });

      tl.set(headingRef.current, { opacity: 1 })
      tl.to(words, { y: 0, skewX: 0, rotateX: 0, opacity: 1, stagger: 0.1 }, "-=0.5")

      return () => {
        tl.kill()
      }
    }, [])

    return (
      <section className={`landing-banner ${theme || ""}${special ? ' special' : ''}`}>
          <div className="landing-banner__asset">
            <BlockUpdate>
              {video && <video className="landing-banner__video" poster={image?.url} src={video} autoPlay loop muted playsInline />}
              {image && !video && <Asset className="landing-banner__bg" asset={image} />}
            </BlockUpdate>
          </div>
          <div className="landing-banner__inner">
            <div className="landing-banner__wrapper">
              <BlockUpdate>
                <div className="landing-banner__title">
                    {title && theme !== "bone" &&
                      <h1 ref={headingRef} style={{ opacity: 0 }}>
                          {title.split(" ").map((el, index) => (
                            <span key={index}><span className={`word ${theme === "bone" ? "bone" : ""}`}>{el}</span></span>
                          ))}
                      </h1>
                    }
                    {
                      title && theme === "bone" &&
                      <h1>{parse(title)}</h1>
                    }
                    {
                      (theme === "edlyn" || special) && buttons?.length > 0 &&
                      <AnimationButton className="btn btn--animation btn--animation-edlyn"
                                        to={buttons[0].link[0].externalLink ? buttons[0].link[0].externalLink : buttons[0].link[0].internalLink?.permalink}>
                          {buttons[0].title}
                      </AnimationButton>
                    }
                </div>
              </BlockUpdate>
              { !special &&
                <div className="landing-banner__buttons">
                    {!theme && buttons?.length > 0 &&
                      <ul>
                          {buttons.map((button, index) => (
                            <li key={index} data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease' data-sal-delay={100 + ((index + 1) * 300)}>
                                <Link to={button.link[0].externalLink}>
                                    {index === 0 && <span><ChefHat /></span>}
                                    {index === 1 && <span><Coffee /></span>}
                                    {index === 2 && <span><International /></span>}
                                    {button.title}<RightArrow color="#FFFFFF" />
                                </Link>
                            </li>
                          ))}
                      </ul>
                    }
                </div>
              }
            </div>
          </div>
      </section>
    )
}

export default LandingBanner

export const query = graphql`
  fragment LandingBannerProps on DatoCmsLandingBanner {
    ... on DatoCmsLandingBanner {
      id
      title
      buttons {
        ...LinkWithTitleProps
      }
      image {
        ...InternalAssetProps
      }
      video
      special
    }
  }
`
